module.exports = __webpack_public_path__ + "media/images/games/k2gender/gardening-ede7f8e04ebf30ef106420004d7cc0a7.png";